<!--
 * @Author: your name
 * @Date: 2021-01-04 09:21:06
 * @LastEditTime: 2021-01-07 09:18:09
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \sunshineServiceHall\src\components\work\telephone.vue
-->
<template>
  <div style="width: 1200px">
    <div class="tablez_bg">
      <div class="title">
        您当前的位置：
        <router-link to="/home">阳光校务服务大厅</router-link>
        &gt; 服务电话
      </div>
    </div>
    <div class="z_title1" style="margin-top: 10px">服务电话</div>
    <div class="itemsList">
      <div style="display: flex; align-items: center">
        <img
            style="margin-right: 5px"
            src="@/assets/point.jpg"
            width="4"
            height="4"
        />
        <router-link target="_blank" class="STYLE1" to="/work/telephoneInfo"
        >维修电话
        </router-link
        >
      </div>
      <div align="left" class="STYLE1">2020-01-07</div>
    </div>
    <a-pagination style="margin-top: 10px" size="small" :total="1"/>
  </div>
</template>

<script>
import {getAction, postAction} from "@/api/manage";

export default {
  data() {
    return {
      list: [],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      // postAction("/guide/repair/list", {
      //   pageSize: this.pageSize,
      //   pageNum: this.current,
      // }).then((data) => {
      //   this.list = data.data.list;
      //   this.total = data.data.total;
      // });
    },
  },
};
</script>

<style scoped>
.itemsList {
  margin-top: 20px;
  width: 1200px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
